module.exports = __webpack_public_path__ + "static/media/close.01044d6b.svg";